import type { CoreQuestionResource } from '@dmp/qqms/data-access';
import type { StoreState } from '../../state-types';

/** Get the list of only active core question ids by `shortId`, and sorted by priority. */
export const getCoreQuestionActiveShortIdList = (state: StoreState): string[] =>
    Object.values(state.coreQuestions)
        .filter((cq) => cq.attributes.isActive)
        .sort(byPriority)
        .map((cq) => cq.attributes.shortId);

/**
 * Sort function that sorts Core Question Resources by priority (highest-to-lowest).
 */
export function byPriority(
    a: CoreQuestionResource,
    b: CoreQuestionResource
): number {
    return b.attributes.priority - a.attributes.priority;
}
